import * as types from "./actionTypes";

const initialState = {
  data: [],
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CHANNELS_SET:
      return {
        ...state,
        data: action.payload,
      };
    case types.CHANNELS_GET_SUCCESS:
      return {
        ...state,
        data: [...state.data, ...action.payload],
        loading: !!action.payload.length,
      };
    case types.CHANNELS_RESET:
      return initialState;

    default:
      return state;
  }
};
